import { JsonView, darkStyles } from "react-json-view-lite";

export function JsonViewer({ json }: { json: string }) {
  return (
    <JsonView
      data={json || {}}
      shouldExpandNode={(level) => level === 0}
      style={darkStyles}
    />
  );

}
